import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface ContractEditorViewProps {
    productRequest: DropdownRequest<ContractSummary>;
    value: number | null;
    mode: ControlMode;
    onChanged: (number: ContractSummary | null) => void;
    label?: string;
	productId?: number;
	required?: boolean

}

export class ContractEditorView extends React.Component<ContractEditorViewProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        let label = this.props.label;
        if (label === undefined) {
            label = 'Contract';
        }
        return (
            <DropdownView
				label={label}
				required={this.props.required}
                disabled={this.props.mode == 'display'}
                model={this.props.value}
                onChanged={(item) => { this.props.onChanged(item != null ? item : null) }}
                request={this.props.productRequest}
                keyField='id'
                textField='displayName'
                cascadeValue={this.props.productId}
                cascadeField='productId'
            />
        );
    }
}




// WEBPACK FOOTER //
// ./src/app/products/contract/parts/contract-editor.view.tsx